// 大陆微信公众号
export const wxConfig = {
  appId: 'wxfa70a6be2e6fbed6',
}

export const getLiffConfig = () => {
  // query
  if (process.env.API_CONFIG.Terminal === 'BIND_ANDROID_JP') {
    if (/linedev=1/.test(window.location.search)) {
      return { liffId: '1657369571-yOQwWKlg' }
    }

    if (/linereview=1/.test(window.location.search)) {
      return { liffId: '1657369572-bgyP3qeZ' }
    }

    if (/lineprod=1/.test(window.location.search)) {
      return { liffId: '1657369573-brkOjzZD' }
    }

    // production setting
    if (window.location.hostname === 'imei-jp.charge-spot.com') {
      return { liffId: '1657369573-brkOjzZD' }
    }

    return { liffId: '1657369571-yOQwWKlg' }
  }

  if (process.env.API_CONFIG.Terminal === 'BIND_ANDROID_TW') {
    if (/linedev=1/.test(window.location.search)) {
      return { liffId: '2007926620-lvMmQemA' }
    }

    if (/linereview=1/.test(window.location.search)) {
      return { liffId: '2007926620-lvMmQemA' }
    }

    if (/lineprod=1/.test(window.location.search)) {
      return { liffId: '2007943417-RaGkKpAB' }
    }

    // production setting
    if (window.location.hostname === 'imei-tw.charge-spot.com') {
      return { liffId: '2007943417-RaGkKpAB' }
    }

    return { liffId: '2007926620-lvMmQemA' }
  }
  return { liffId: '1657369571-yOQwWKlg' }
}

// 环境变量传入配置
export const config = process.env.API_CONFIG
